import React from 'react';
import { Typography, Button, makeStyles } from '@material-ui/core';
import WarnIcon from '@material-ui/icons/ReportProblem';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    padding: '1rem',
    backgroundColor: 'rgba(255, 207, 0, 0.35)',
    borderRadius: '0.5rem',
    gap: '1rem',
    flexWrap: 'wrap'
  },
  text: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#171717',
    flex: 1,
    minWidth: '200px'
  },
  icon: {
    fill: '#ea8f08'
  },
  wrapper: {
    minHeight: '3rem'
  },
  padding: {
    padding: '1rem'
  }
});

interface Props {
  text: any;
  buttonLabel?: string;
  onButtonClick?: () => void;
  noPadding?: boolean;
}

const Warning = ({
  text,
  buttonLabel,
  onButtonClick,
  noPadding = false
}: Props) => {
  const classes = useStyles();

  return (
    <div className={`${classes.wrapper} ${noPadding ? '' : classes.padding}`}>
      <div className={classes.container}>
        <WarnIcon className={classes.icon} />
        <Typography className={classes.text}>{text}</Typography>
        {buttonLabel && onButtonClick && (
          <Button
            variant="contained"
            color="secondary"
            size="medium"
            onClick={onButtonClick}
            style={{ width: '100%' }}
          >
            {buttonLabel}
          </Button>
        )}
      </div>
    </div>
  );
};

export default Warning;
